import { useTranslation } from "react-i18next";
import { Editor } from "@tiptap/react";
import { mdiFormatStrikethrough } from "@mdi/js";
import { FormattingToggle } from "./FormattingToggle";

type Props = {
  editor: Editor;
};

export function StrikeFormattingToggle({ editor }: Props) {
  const { t } = useTranslation();

  return (
    <FormattingToggle
      icon={mdiFormatStrikethrough}
      tooltip={t("StrikeFormattingToggle.tooltip")}
      pressed={editor.isActive("strike")}
      onPressedChange={() => editor.chain().focus().toggleStrike().run()}
    />
  );
}
